import { Image, Member } from '@tribeplatform/gql-client/types'
import { useRouter } from '@tribeplatform/react-sdk'
import { Avatar } from '@tribeplatform/react-ui-kit/Avatar'
import { Badge } from '@tribeplatform/react-ui-kit/Badge'

export const MemberPill = ({ member }: { member: Member }) => {
  const { Link } = useRouter()
  if (!member?.name) {
    return null
  }

  return (
    <Link href={member?.relativeUrl} className="rounded-full" translate="no">
      <Badge
        variant="secondary"
        rounded
        className="ps-1"
        leadingIcon={
          <Avatar
            size="xs"
            src={(member?.profilePicture as Image)?.urls?.thumb}
            name={member?.name}
          />
        }
      >
        {member?.name}
      </Badge>
    </Link>
  )
}
